import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import { Divider, Switch } from "@mui/material";
import Button from "../../../Admin-Dashboard/@common/Button";
import TextArea from "../../../Admin-Dashboard/@common/TextArea";
import BreadCrumb from "../../../Admin-Dashboard/@components/Breadcrumb";
import FileUploader from "./FileUploader";
import { postScrubberData } from "../../../Admin-Dashboard/apiHandler/preference.service";
import { useDispatch } from "react-redux";
import { setMessage } from "../../../store/slices/Notification";
// import { Column } from "../../../interfaces/table";
import ReusableTable from "../../../Admin-Dashboard/@components/Table";
import ExportCSV from "./CSVDownloader";

const CSV_HEADER_MAPPER: any = {
  mobileNumber: "Mobile Number",
  whatsappMessages: "Whatsapp Messages",
  smsNotifications: "SMS Notification",
  emailNotifications: "Email Notification",
  pushNotifications: "Push Notifications",
  rcsNotifications: "RCS Notifications",
  calls: "Calls",
  enableAll: "Enable All"
};

const columns: any = {
  mobileNumber: {
    id: "mobileNumber",
    label: "Mobile Number",
    minWidth: 170,
    align: "center",
    key: "mobileNumber",
    isSortable: false,
  },
  whatsappMessages: {
    id: "actions",
    label: "Whatsapp notification",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled={true} checked={row?.whatsappMessages === undefined || row?.whatsappMessages} />
        </div>
      );
    },
  },
  enableAll: {
    id: "actions",
    label: "Whatsapp notification",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled={true} checked={row?.enableAll === undefined || row?.enableAll} />
        </div>
      );
    },
  },
  smsNotifications: {
    id: "actions",
    label: "Sms Notifications",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled checked={row?.smsNotifications === undefined || row?.smsNotifications} />
        </div>
      );
    },
  },
  emailNotifications: {
    id: "actions",
    label: "Email notifications",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled checked={row?.emailNotifications === undefined || row?.emailNotifications} />
        </div>
      );
    },
  },
  pushNotifications: {
    id: "actions",
    label: "Push notifications",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled checked={row?.pushNotifications === undefined || row?.pushNotifications} />
        </div>
      );
    },
  },
  rcsNotifications: {
    id: "actions",
    label: "Rcs notifications",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled checked={row?.rcsNotifications === undefined || row?.rcsNotifications} />
        </div>
      );
    },
  },
  calls: {
    id: "actions",
    label: "Calls",
    minWidth: 100,
    align: "center",
    key: "actions",
    isSortable: false,
    render: (_: any, row: any) => {
      return (
        <div className="flex justify-center items-center gap-2">
          <Switch disabled checked={row?.calls === undefined || row?.calls} />
        </div>
      );
    },
  },
};

const Scrubber = () => {
  const [value, setValue] = useState("");
  const [preferences, updatePreferences] = useState<string[]>([]);

  const [fixedPreference, updateFixedPreferences] = useState<string[]>([]);

  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    let input = event.target.value;
    input = input.replace(/[^0-9]/g, ""); // Remove non-numeric characters

    // Insert a comma after every 10th digit (for multiples of 10)
    const formattedInput = input.replace(/(\d{10})(?=\d)/g, "$1,");

    setValue(formattedInput);
  };

  const [tableData, updateTableData] = useState([]);

  const onSave = async () => {
    try {
      if (!preferences?.length) {
        dispatch(
          setMessage({
            type: "error",
            message: "Add At least 1 preference",
          })
        );
        return
      }
      const mobileNumbers = value.split(",");
      if (mobileNumbers[mobileNumbers.length - 1].length !== 10) {
        dispatch(
          setMessage({
            type: "error",
            message: "All mobile numbers must be 10-digit numbers.",
          })
        );
        return;
      }
      const resp = await postScrubberData({ mobileNumbers: [...new Set(mobileNumbers)], preferences });
      console.log("updateTableData", resp);
      updateTableData(resp);
      dispatch(
        setMessage({
          type: "success",
          message: "Data has been Saved",
        })
      );
    } catch (err) {
      dispatch(
        setMessage({
          type: "error",
          message: "Something went wrong Try Again!",
        })
      );
    } finally {
      updateFixedPreferences(preferences);
    }
  };

  // Toggle handler for updating preferences array
  const handleToggle = (label: string, checked: boolean) => {
    updatePreferences(
      (prev) =>
        checked
          ? [...prev, label] // Add label if switch is turned on
          : prev.filter((item) => item !== label) // Remove label if switch is turned off
    );
  };

  return (
    <div className="flex">
      <Sidebar
        active_link="/dashboard/user-notification/number-scrubber"
        type="data_collection"
        title="Dashboard"
        options={[
          {
            icon: "/sidebarIcon/award.svg",
            label: "Number Scrubber",
            link: "/dashboard/user-notification/number-scrubber",
          },
          {
            icon: "/sidebarIcon/celebrity.svg",
            label: "Preference",
            link: "/dashboard/user-notification",
          },
        ]}
      />
      <div className="pl-8 w-[75%] dashboard-image mt-20">
        <div className="header-container">
          <div>
            <BreadCrumb
              breadCrumbArray={[
                { label: "Dashboard", link: "/dashboard" },
                { label: "Number Scrubber", link: "" },
              ]}
            />
          </div>
          <Button onClick={onSave} variant="contained">
            Save
          </Button>
        </div>
        <div className="flex flex-col">
          <div className="grid grid-cols-4 mt-4 gap-2">
            {[
              // { label: "Enable All", key: "enableAll" },
              { label: "Whatsapp Messages", key: "whatsappMessages" },
              { label: "SMS Notifications", key: "smsNotifications" },
              { label: "Email Notifications", key: "emailNotifications" },
              { label: "Push Notifications", key: "pushNotifications" },
              { label: "RCS Notifications", key: "rcsNotifications" },
              { label: "Calls", key: "calls" },
            ].map((item) => (
              <div key={item.key} className="flex items-center gap-2">
                <p>{item.label}</p>
                <Switch onChange={(e) => handleToggle(item.key, e.target.checked)} />
              </div>
            ))}
          </div>
          <FileUploader updateFixedPreferences={updateFixedPreferences} preferences={preferences} updateTableData={updateTableData} />
          <Divider className="!my-8" />
          <div>
            <label>
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <TextArea
              value={value}
              className="w-full !mt-2"
              placeholder="Write phone numbers comma separated"
              handleChange={handleChange}
            />
          </div>
          <div className="flex w-full justify-end my-4">
            {tableData.length ? (
              <ExportCSV
                data={tableData?.map((row: any) => {
                  return {
                    ...row,
                    whatsappMessages: row?.whatsappMessages === undefined || row?.whatsappMessages,
                    smsNotifications: row?.smsNotifications === undefined || row?.smsNotifications,
                    emailNotifications: row?.emailNotifications === undefined || row?.emailNotifications,
                    pushNotifications: row?.pushNotifications === undefined || row?.pushNotifications,
                    rcsNotifications: row?.rcsNotifications === undefined || row?.rcsNotifications,
                    calls: row?.calls === undefined || row?.calls,
                  };
                })}
                columns={[
                  { key: "mobileNumber", label: "Mobile Number" },
                  ...fixedPreference?.map((item: any) => ({ key: item, label: CSV_HEADER_MAPPER[item] })),
                ]}
                fileName="Mobile_Scrubber_Data"
              />
            ) : null}
          </div>

          {tableData.length ? (
            <div className="header-body">
              <ReusableTable
                columns={[columns["mobileNumber"], ...fixedPreference?.map((item: any) => columns[item])]}
                rows={tableData}
                loading={false}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Scrubber;
